import React from 'react';

import { PrimaryButton } from '@components/Button/variants';
import useServerSideRendering from '@hooks/useServerSideRendering';
import useWindowSize from '@hooks/useWindowSize';
import { getImgixSrc } from '@utils/images';

interface BrandCampaignHeaderProps {
  isSubscriber: boolean;
  subscribePromoUrl: string;
}

const Header = ({ isSubscriber, subscribePromoUrl }: BrandCampaignHeaderProps) => {
  const { width: windowWidth } = useWindowSize();
  const hydrated = useServerSideRendering();

  return (
    <div className="mx-auto mt-20 flex justify-center border-0 border-b border-solid border-grayscale-gray sm:mt-0 lg:justify-end">
      <div className="flex flex-wrap justify-between !px-16 sm:flex-col-reverse sm:!px-24 md:w-full lg:w-10/12 lg:flex-row lg:!px-0">
        <div className="pb-48 pr-24 sm:mt-24 sm:pb-64 md:w-full lg:mt-64 lg:w-7/12">
          <div className="font-suisse-works text-headline-lg font-medium text-primary-magenta md:text-headline-xl">
            Read The Information first…
            <span className="block text-black">
              {' '}
              or <em>them</em> later
            </span>
          </div>
          <div className="text-style body-lg mb-24 mt-8 font-suisse-neue font-normal text-[#6d686e] lg:max-w-[520px]">
            The Information journalists get the news that other newsrooms envy. That’s why our
            coverage of exclusive deals, product launches and strategic moves were followed by the
            New York Times, Bloomberg, the Wall Street Journal and dozens of other outlets more than
            400 times in the last year.
          </div>
          <div className="font-suisse-neue text-headline-sm font-bold">
            Get the news straight from the source.
          </div>
          {!isSubscriber && (
            <PrimaryButton
              className="mt-8 w-[240px] font-suisse-intl !text-body-lg"
              as="link"
              href={subscribePromoUrl}
            >
              Subscribe
            </PrimaryButton>
          )}
        </div>
        {hydrated &&
          (windowWidth > 1200 ? (
            <div className="flex-shrink-0 lg:w-5/12">
              <img
                className="h-full w-full object-cover"
                src={getImgixSrc({
                  path: 'brand_campaign/ReadUsFirstHeaderDesktop.png?auto=compress,format',
                  isEnvDependent: false,
                })}
                alt="Hero Image"
              />
            </div>
          ) : (
            <div className="w-full flex-shrink-0">
              <img
                className="hidden max-w-lg sm:flex sm:w-full sm:max-w-full"
                src={getImgixSrc({
                  path: 'brand_campaign/ReadUsFirstHeaderTablet.png?auto=compress,format',
                  isEnvDependent: false,
                })}
                alt="Hero Image"
              />
            </div>
          ))}
      </div>
    </div>
  );
};

export default Header;
